export const CARD_ASPECT_RATIO = 3 / 4;
export const RELATIVE_CARD_HEIGHT = 0.9;
export const RELATIVE_CARD_HEIGHT_STRING = "90%";
